const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken;
  };

  const getSToken = () => {
    const tokenString = sessionStorage.getItem('stoken');
    const userToken = JSON.parse(tokenString);
    return userToken;
  };

  
export {
  getToken,
  getSToken
}